import apiDB from './api_db';

let admin = new apiDB({
    api_module: 'admin',
    table_key_name: 'admin_id',
    reducer_name: 'adminR',
    reducer_var: 'admin',
    action_prefix: 'ADMIN'});

export default admin;